<template>
  <div v-if="visible" class="onboarding-sign-modal-backdrop">
    <section class="onboarding-sign-modal bg-white shadow-lg" role="dialog" aria-modal="true" :aria-labelledby="modal_title_id">
      <header class="border-bottom p-4 d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <h2 :id="modal_title_id" class="h5 fw-bold text-black mb-2">Sign &middot; {{ agreementTitle }}</h2>
          <p class="mb-0 text-muted">{{ signatoryName }} &middot; electronic signature (ECTA-compliant)</p>
        </div>
        <button type="button" class="btn btn-link text-muted p-0" aria-label="Close signing modal" @click="close">
          <i class="bi bi-x-lg fs-5"></i>
        </button>
      </header>

      <div class="p-4">
        <article class="rounded-3 border bg-light p-3 mb-4">
          <div class="d-flex align-items-start gap-3">
            <i class="bi bi-file-earmark-text fs-5 text-black"></i>
            <div class="min-w-0 flex-grow-1">
              <div class="fw-bold text-black mb-2">{{ agreementTitle }}</div>
              <p class="text-muted mb-3">
                This document confirms the terms of the {{ signatoryName }} engagement. By adopting your
                signature below you agree to be legally bound, and consent to transact electronically under
                the Electronic Communications and Transactions Act.
              </p>
              <div class="d-flex align-items-center justify-content-between gap-3 text-muted small">
                <span>Document ID &middot; {{ documentId }}</span>
                <span>1 page</span>
              </div>
            </div>
          </div>
        </article>

        <label class="text-uppercase text-muted fw-semibold small mb-2" for="agreement-signatory-name">
          Full legal name of signatory
        </label>
        <input
          id="agreement-signatory-name"
          v-model="local_signatory_name"
          type="text"
          class="form-control mb-3"
        >

        <div class="onboarding-signature-box rounded-3 border p-3 mb-3">
          <div class="text-uppercase text-muted small mb-2">Your signature</div>
          <div class="onboarding-signature">{{ local_signatory_name || signatoryName }}</div>
        </div>

        <label class="d-flex align-items-start gap-3 mb-0">
          <input v-model="has_consented" class="form-check-input mt-1" type="checkbox">
          <span>I am the named signatory and I consent to sign this document electronically.</span>
        </label>
      </div>

      <footer class="border-top p-3 d-flex justify-content-end gap-3">
        <button type="button" class="btn btn-link text-muted text-decoration-none fw-semibold" @click="close">Cancel</button>
        <button
          type="button"
          class="btn btn-primary d-inline-flex align-items-center gap-2 fw-semibold"
          :disabled="!can_sign"
          @click="sign"
        >
          <i class="bi bi-check2-square"></i>
          <span>Adopt &amp; sign</span>
        </button>
      </footer>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AgreementSignModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agreementTitle: {
      type: String,
      default: 'Agreement'
    },
    signatoryName: {
      type: String,
      default: ''
    },
    documentId: {
      type: String,
      default: 'DOC-MAIN-2026'
    }
  },
  emits: ['close', 'signed'],
  data: () => ({
    has_consented: false,
    local_signatory_name: ''
  }),
  computed: {
    modal_title_id() {
      return 'agreement-sign-title';
    },
    can_sign() {
      return this.has_consented && Boolean(String(this.local_signatory_name || '').trim());
    }
  },
  watch: {
    visible(next_visible) {
      if (next_visible) {
        this.has_consented = false;
        this.local_signatory_name = this.signatoryName;
      }
    },
    signatoryName: {
      immediate: true,
      handler(next_name) {
        if (!this.visible) {
          this.local_signatory_name = next_name;
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    sign() {
      if (!this.can_sign) {
        return;
      }

      this.$emit('signed', {
        agreement_title: this.agreementTitle,
        signatory_name: this.local_signatory_name
      });
    }
  }
};
</script>
